const e = {
  extends: "MillionaireForLife",
  logo: !0
};
export {
  e as default
};
